<template>
  <div class="headerBoxInfo row no-gutters">
    <span class="headerBoxInfo_text">{{ ` ${this.text} ` }}</span>
    <span class="headerBoxInfo_info"
          :class="{hideMe: !this.info}">{{ ` ${this.info} ` }}</span>
  </div>
</template>

<script>
  export default {
    name: "HeaderBoxInfo",
    props: ['info', 'text'],
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .headerBoxInfo {
    color: $color-dark;
    font-size: pxToRem(14);
    font-weight: 500;
    max-width: pxToRem(120);

    &_text,
    &_info {
      display: inline-block;
      line-height: pxToRem(14);
      min-height: pxToRem(14);
      width: 100%;
    }

    &_text {
      border-bottom: pxToRem(1) solid $color-dark;
    }

    &_info {
      word-break: break-all;

    }
  }

  .hideMe {
    visibility: hidden;
  }
</style>
